import React from 'react';
import { ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { StyledModal, StyledInlineErrorMessage } from './styled';
import { StyledModalHeaderIcon } from '@/shared';
import { Button } from 'antd';
import { Grid } from '@mantine/core';
import '@/styles/app.css'

const DeleteButtonModal = ({
  onClose,
  isLoading,
  isOpen,
  onSubmit,
  forceDelete
}) => {
  return (
    <StyledModal size="md" centered isOpen={isOpen}>
      <ModalHeader toggle={onClose} disabled={isLoading}>
        <StyledModalHeaderIcon icon="plus" />Delete project entry
      </ModalHeader>
      <ModalBody>
        <Grid>
          <Grid.Col>
            Delete this project from this and future weeks?
          </Grid.Col>
        </Grid>
        {forceDelete && 
          <Grid>
            <Grid.Col>
              <StyledInlineErrorMessage>Deleting will remove all time entries from this and future weeks. Prior weeks will remain.</StyledInlineErrorMessage>
            </Grid.Col>
          </Grid>
        }
      </ModalBody>
      <ModalFooter>
        <Button className="secondary-antd-button" primary outline onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button 
          className="primary-antd-button"
          primary 
          onClick={() => onSubmit()}
          loading={isLoading}
        >
          Delete
        </Button>
      </ModalFooter>
    </StyledModal>
  );
};

export default DeleteButtonModal;